module.exports = __webpack_public_path__ + "static/media/PrecentBlackFlat.725f18cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/PrecentBlackFlat.svg
// module id = 196
// module chunks = 0